import * as yup from 'yup'
import { Controller, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'

import { InviteResult, usePostInviteReject } from 'interface/user/invite'

import { Stack, TextField } from '@mui/material'

const formSchema = yup.object().shape({
  comment: yup
    .string()
    .nullable()
})

type useInviteRejectFormProps = {
  invite: InviteResult,
  onSubmit: (inviteId: number) => void
}
export const useInviteRejectForm = ({
  invite,
  onSubmit
}: useInviteRejectFormProps) => {
  const form = useForm({
    defaultValues: {
      comment: ''
    },
    mode: 'onChange',
    criteriaMode: 'all',
    resolver: yupResolver(formSchema)
  })
  const [postState, applovalInvite] = usePostInviteReject({ onPosted: onSubmit })
  return {
    ...form,
    invite,
    postState,
    submit: form.handleSubmit(input => applovalInvite({
      inviteId: invite.inviteId,
      form: {
        comment: input.comment ?? ''
      }
    }))
  }
}

export const InviteRejectForm = ({
  control,
  formState: { errors }
}: ReturnType<typeof useInviteRejectForm>) => (
  <Stack direction="column">
    <Controller
      control={control}
      name="comment"
      render={({ field }) => (
        <TextField
          {...field}
          variant="outlined"
          placeholder="メッセージ"
          size="small"
          multiline
          rows={10}
          error={!!errors.comment}
          helperText={errors.comment ? errors.comment.message : ''}
        />
      )}
    />
  </Stack>
)
